"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinleyAiPromptResponseTerminalStatuses = exports.FinleyAiTransformSupportedFileExtensionSchema = exports.FinleyAiTransformSupportedFileExtensionIterable = exports.FinleyAiTextractSupportedFileExtensionSchema = exports.FinleyAiTextractSupportedFileExtensionIterable = exports.FinleyAiExtractValuesPageNumberSupportedFileExt = exports.FinleyAiExtractValuesFileExtToEngineSupport = exports.FinleyAiExtractValuesEngineFileExtSupport = exports.FinleyAiExtractValuesDefaultEngine = exports.FinleyAiVirtualSheetSupportedFileExtensionIterable = exports.FinleyAiExtractValuesSupportedFileExtensionSchema = exports.FinleyAiExtractValuesSupportedFileExtensionIterable = exports.FinleyAiExtractValuesEngineSchema = exports.finleyAiVirtualSheetFormulaQuestionsSchema = exports.finleyAiVirtualSheetFormulaQuestionSchema = void 0;
const zod_1 = require("zod");
exports.finleyAiVirtualSheetFormulaQuestionSchema = zod_1.z.object({
    fieldName: zod_1.z.string(), // name of the field to extract
    fieldPrompt: zod_1.z.string(), // question to ask the LLM for the field.
});
exports.finleyAiVirtualSheetFormulaQuestionsSchema = zod_1.z
    .array(exports.finleyAiVirtualSheetFormulaQuestionSchema)
    .min(1);
exports.FinleyAiExtractValuesEngineSchema = zod_1.z.enum([
    'pdfMiner',
    'textract',
    'beautifulSoup',
    'rawText',
]);
exports.FinleyAiExtractValuesSupportedFileExtensionIterable = [
    'pdf',
    'html',
    'png',
    'jpeg',
    'jpg',
    'tiff',
    'tif',
    'txt',
    'json',
];
exports.FinleyAiExtractValuesSupportedFileExtensionSchema = zod_1.z.enum(exports.FinleyAiExtractValuesSupportedFileExtensionIterable);
exports.FinleyAiVirtualSheetSupportedFileExtensionIterable = Object.freeze(['xlsx', 'xlsb', 'xlsm']);
exports.FinleyAiExtractValuesDefaultEngine = {
    html: 'beautifulSoup',
    pdf: 'pdfMiner',
    jpeg: 'textract',
    jpg: 'textract',
    json: 'rawText',
    png: 'textract',
    tif: 'textract',
    tiff: 'textract',
    txt: 'rawText',
};
exports.FinleyAiExtractValuesEngineFileExtSupport = {
    beautifulSoup: ['html'],
    textract: ['pdf', 'png', 'jpeg', 'jpg', 'tif', 'tiff'],
    pdfMiner: ['pdf'],
    rawText: ['txt', 'json'],
};
// reverse map of FinleyAiExtractValuesEngineFileExtSupport
exports.FinleyAiExtractValuesFileExtToEngineSupport = Object.entries(exports.FinleyAiExtractValuesEngineFileExtSupport).reduce((acc, [eng, exts]) => {
    exts.forEach((ext) => {
        acc[ext].push(eng); // guaranteed by type system, Object.entries loses typing
    });
    return acc;
}, {
    html: [],
    pdf: [],
    png: [],
    jpeg: [],
    jpg: [],
    json: [],
    tiff: [],
    tif: [],
    txt: [],
});
exports.FinleyAiExtractValuesPageNumberSupportedFileExt = [
    'pdf',
    'png',
    'jpeg',
    'jpg',
    'tiff',
    'tif',
];
exports.FinleyAiTextractSupportedFileExtensionIterable = [
    'pdf',
    'png',
    'jpeg',
    'jpg',
    'tif',
    'tiff',
];
exports.FinleyAiTextractSupportedFileExtensionSchema = zod_1.z.enum(exports.FinleyAiTextractSupportedFileExtensionIterable);
exports.FinleyAiTransformSupportedFileExtensionIterable = [
    'pdf',
    'html',
    'png',
    'jpeg',
    'jpg',
    'tiff',
    'tif',
    'json',
    'csv',
    'xlsx',
    'xlsb',
];
exports.FinleyAiTransformSupportedFileExtensionSchema = zod_1.z.enum(exports.FinleyAiTransformSupportedFileExtensionIterable);
exports.FinleyAiPromptResponseTerminalStatuses = [
    'failure',
    'success',
];
//# sourceMappingURL=FinleyAi.js.map